/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';

import { IoMdArrowForward, IoMdArrowBack } from 'react-icons/io';
import OptimizedImage from '../OptimizedImage';

import Carousel from '../Carousels/SingleItemFadeCarousel';
import HomeTestimonialsCard from '../Home/HomeTestimonialsCard';

export default () => {
  const sliderRef = useRef(null);

  const goNext = () => {
    if (sliderRef !== null) {
      sliderRef.current.next();
    }
  };

  const goPrev = () => {
    if (sliderRef !== null) {
      sliderRef.current.prev();
    }
  };

  const opinionData = [
    {
      content:
        'Great atmosphere, flexible working hours and a big appetite for development and changing the world! ',
      author: {
        title: 'Basia, QA Specialist'
      },
      image: 'Basia.png'
    },
    {
      content:
        "One of the best things about Ulam Labs is that you can feel that you're a part of the community - even when working remotely!",
      author: {
        title: 'Anna Buczak, Content Marketing Manager'
      },
      image: 'AnnaB.png'
    }
  ];

  return (
    <div className="testimonials">
      <div className="container">
        <OptimizedImage
          background
          src="globe.png"
          className="top-beam"
          style={{
            backgroundPosition: '',
            backgroundRepeat: '',
            backgroundSize: '',
            backgroundAttachment: ''
          }}
        />
      </div>
      <div className="container">
        <div className="testimonials-slider main-swiper">
          <div className="swiper-container">
            <Carousel ref={sliderRef}>
              {opinionData.map(singleOpinion => (
                <>
                  <div
                    className="swiper-slide swiper-slide-testimonial sw-pv3"
                    key={`testi-${singleOpinion.id}`}
                  >
                    <HomeTestimonialsCard careers testimonial={singleOpinion} />
                  </div>
                </>
              ))}
            </Carousel>
          </div>
          <div className="navigation-slider">
            <div
              className="nav-button nav-left testi-left"
              aria-label="Show previous testimonial"
              role="button"
              onClick={goPrev}
              tabIndex="0"
            >
              <IoMdArrowBack />
            </div>
            <div
              className="nav-button nav-right testi-right"
              aria-label="Show next testimonial"
              role="button"
              tabIndex="0"
              onClick={goNext}
            >
              <IoMdArrowForward />
            </div>
          </div>
          <div className="swiper-pagination sw-pv3" />
        </div>
      </div>
    </div>
  );
};
